import { render, staticRenderFns } from "./FullLayout.vue?vue&type=template&id=7b41aa18&scoped=true"
import script from "./FullLayout.vue?vue&type=script&lang=js"
export * from "./FullLayout.vue?vue&type=script&lang=js"
import style0 from "./FullLayout.vue?vue&type=style&index=0&id=7b41aa18&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b41aa18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b41aa18')) {
      api.createRecord('7b41aa18', component.options)
    } else {
      api.reload('7b41aa18', component.options)
    }
    module.hot.accept("./FullLayout.vue?vue&type=template&id=7b41aa18&scoped=true", function () {
      api.rerender('7b41aa18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/FullLayout.vue"
export default component.exports